module.exports = __webpack_public_path__ + "static/ayudante.a880f9ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ayudante.svg
// module id = 528
// module chunks = 232435795724502